import Content from './Content';
import Header from './Header';
import Root from './Root';

export default {
  Root,
  Content,
  Header
};
